// eslint-disable-next-line import/prefer-default-export
export const ONE_DAY_IN_MILLISECONDS = 1000 * 60 * 60 * 24;
